"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Pro16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5.09859L7.97266 2.19719L12.9961 5.09859V10.9014L7.97266 13.8028L3 10.9014V5.09859ZM7.46747 0.136616C7.78008 -0.0455388 8.16523 -0.0455388 8.47784 0.136616L14.4675 3.62676C14.7801 3.80891 15 4.14555 15 4.50986L14.9727 11.4901C14.9727 11.8545 14.7801 12.1911 14.4675 12.3732L8.47784 15.8634C8.16523 16.0455 7.78008 16.0455 7.46747 15.8634L1.47784 12.3732C1.16523 12.1911 1 11.8545 1 11.4901V4.50986C1 4.14555 1.16523 3.80891 1.47784 3.62676L7.46747 0.136616ZM6.29573 8.8609L6.10934 10.9094L7.99998 10.0991L9.89062 10.9094L9.70422 8.8609L11.0591 7.31318L9.05326 6.85743L7.99998 5.0906L6.9467 6.85743L4.94086 7.31318L6.29573 8.8609Z", fill: "#383F49" }));
}
function Pro16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Pro16Svg, Object.assign({}, svgProps)));
}
exports.default = Pro16;
//# sourceMappingURL=Pro16.js.map